"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _getCurrentApplication = _interopRequireDefault(require("../helpers/getCurrentApplication"));

var _getAppFromLinkPathname = _interopRequireDefault(require("../helpers/getAppFromLinkPathname"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * simple component that determines whether or not to use `react-router` or
 * a normal `<a />`
 */


function AppLink(_ref) {
  var className = _ref.className,
      to = _ref.to,
      children = _ref.children,
      activeClassName = _ref.activeClassName,
      restOfProps = _objectWithoutProperties(_ref, ["className", "to", "children", "activeClassName"]);

  if ((0, _getAppFromLinkPathname["default"])(to) === (0, _getCurrentApplication["default"])()) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, _extends({
      className: className,
      to: to,
      activeClassName: activeClassName
    }, restOfProps), children);
  }

  return /*#__PURE__*/_react["default"].createElement("a", _extends({
    className: className,
    href: "".concat(window.location.origin).concat(to)
  }, restOfProps), children);
}

var _default = AppLink;
exports["default"] = _default;